export const environment = {
    production: false,
    url: "https://api-spxexpress-claims.policystreet.app",
};
